var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCl = function SvgCl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43 32",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0h32v16H16V0z",
    fill: "rgba(253, 253, 253, 0.99608)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0V0z",
    fill: "rgba(86, 81, 169, 0.99608)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.49 11.982l-2.48-1.86L5.546 12l.917-3.05L4 7.067l3.046-.026L7.99 4l.966 3.034 3.046.004-2.45 1.9.938 3.044z",
    fill: "rgba(253, 253, 253, 0.99608)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16h48v16H0V16z",
    fill: "rgba(237, 40, 0, 0.99608)"
  })));
};
export default SvgCl;